import { format } from "date-fns";
import { cn } from "@/lib/utils";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Button, Calendar } from "../ui";
import { CalendarIcon, CircleX } from "lucide-react";
import { useState } from "react";
import moment from "moment";

const DatePicker = ({
  date,
  setDate,
  disabled,
  maxDate,
  minDate,
  onClear,
}: any) => {
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild disabled={disabled}>
        <Button
          variant="outline"
          className={cn(
            "w-full items-center bg-transparent justify-between text-left font-normal h-[40px] text-sidebar-foreground group relative",
            !date && "text-muted-foreground"
          )}
          disabled={disabled}
        >
          {date ? <span className="text-overflow-hide">{format(date, "PPP")}</span> : <span className="text-overflow-hide">Please Select</span>}
          {date ? (
            <div
              className="h-5 w-5 cursor-pointer flex items-center justify-end"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation(); // Prevents triggering the button click
                onClear && onClear();
                setDate("");
              }}
            >
              <CircleX className="stroke-gray-500 group-hover:stroke-black" />
            </div>
          ) : (
            <CalendarIcon className="mr-2 h-4 w-4" />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="single"
          selected={new Date(date)}
          onSelect={(selectedDate) => {
            if (selectedDate) {
              const _selectedDate = moment(selectedDate).format(
                "YYYY-MM-DDTHH:mm:ss"
              );

              if (
                minDate &&
                maxDate &&
                moment(_selectedDate).isSameOrAfter(moment(minDate)) &&
                moment(_selectedDate).isSameOrBefore(moment(maxDate))
              ) {
                setDate(_selectedDate);
              } else if (
                _selectedDate &&
                minDate &&
                moment(_selectedDate).isSameOrAfter(moment(minDate))
              ) {
                setDate(_selectedDate);
              } else if (
                _selectedDate &&
                maxDate &&
                moment(_selectedDate).isSameOrBefore(moment(maxDate))
              ) {
                setDate(_selectedDate);
              } else {
                setDate(_selectedDate);
              }
              setOpen(false);
            }
          }}
          disabled={(day) => day < minDate || day > maxDate}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
};

export default DatePicker;
